import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    padding: theme.spacing(4),
    width: '100%'
  }
}));

export const PageLoadingIndicator = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.container} data-testid='loading-indicator'>
      <CircularProgress size={40} />
    </div>
  );
};
